import React, { Fragment } from "react";
import { HelpButton } from "./common/HelpButton";

export const QuestionnairePageHeader = ({
	title,
	textColor,
	currentPage,
	numOfPages,
	onHelpClick,
	background,
}) => {
	return (
		<Fragment>
			<div className={"relative m-safeAreaTop h-16"}>
				{onHelpClick ? (
					<div className={"absolute right-3 top-2"}>
						<HelpButton onClick={onHelpClick} color={"white"} />
					</div>
				) : null}
				<h1
					className={`text-black w-full text-center font-medium text-md sm:text-xl max-w-2xl mx-auto`}
				>
					{title}
				</h1>
				{currentPage && numOfPages ? (
					<p
						className={`text-sm text-black opacity-70 font-medium text-center py-2-mt-2`}
					>
						Page {currentPage} of {numOfPages}
					</p>
				) : null}
			</div>
			<span
				className={`flex ${background} w-full rounded-t-xxl pt-5 top-shadow`}
			>
				<span
					className={`bg-white flex flex-col items-center w-full pt-7 rounded-t-xxl`}
				></span>
			</span>
		</Fragment>
	);
};
